(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/password-recovery.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/password-recovery.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const LOGIN = svs.ticket_partner.constants.routes.LOGIN;
const _svs$ticket_partner$p = svs.ticket_partner.passwordRecovery,
  RecoveryEmailForm = _svs$ticket_partner$p.RecoveryEmailForm,
  PasswordRecoveryForm = _svs$ticket_partner$p.PasswordRecoveryForm;
const _React = React,
  useState = _React.useState;
const PasswordRecovery = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    restoreOptions = _useState4[0],
    setRestoreOptions = _useState4[1];
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(LOGIN),
    redirectToReturnUrl = _svs$ticket_partner$s.redirectToReturnUrl;
  const onRestoreOptionsChange = options => {
    setRestoreOptions(options);
  };
  const onRecoveySuccess = () => {
    setEmail('');
    setRestoreOptions([]);
    redirectToReturnUrl();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 5
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 10
  }, restoreOptions.length === 0 ? React.createElement(RecoveryEmailForm, {
    email: email,
    onEmailChange: e => setEmail(e.target.value),
    onRestoreOptionsChange: onRestoreOptionsChange
  }) : React.createElement(PasswordRecoveryForm, {
    email: email,
    onRecoveySuccess: onRecoveySuccess,
    restoreOptions: restoreOptions
  }))));
};
svs.ticket_partner.passwordRecovery.PasswordRecovery = PasswordRecovery;

 })(window);